<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="E-mail">
        <input class="form-input" v-model="config.auth.email">
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.token">
      </form-group>
      <form-group label="Código da loja">
        <input class="form-input" v-model="config.auth.storeCode">
      </form-group>
    </div>
    
    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>

    <panel v-if="(this.shippingMethods && this.shippingMethods.length)" title="Transportadoras">
      <label>Códigos</label>
      <div class="l-row" v-for="shippingMethod in this.shippingMethods">
        <form-group>
          <label>{{ shippingMethod.name }} - {{ shippingMethod.identifier }}</label>
          <input class="form-input" v-model="config.shipping.methods[shippingMethod.identifier]">
        </form-group>
      </div>
    </panel>
  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import api from '@/api'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'polishop'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'polishop',
      shippingMethods: [],
      config: {
        auth: {
          environment: 'sandbox',
          sandboxUrl: 'https://teste.conectala.com.br',
          productionUrl: 'https://sellercenter.polishop.com.br',
          subModuleIdentifier: 'polishop',
          email: null,
          token: null,
          storeCode: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        shipping: {
          methods: {}
        },
        quotation: {
          shipmentMethod: null
        },
        webhook: {
          sellerId: null
        }
      }
    }),
    async mounted () {
      await api.getMarketplaceShippingMethods('polishop')
        .then(data => {
          this.shippingMethods = data
        })
        .catch(() => { })
    },
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Polishop.vue?5569f261